import {
  FETCH_RECOMMENDATION_REQUEST,
  FETCH_RECOMMENDATION_SUCCESS,
} from './AiRecommendations.constants';

const initialState = {
  data: {},
  loading: {},
  error: {},
};

export default function AiRecommendationsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_RECOMMENDATION_REQUEST: {
      const key = `${payload.pageName}_${payload.category}`;
      return {
        ...state,
        loading: { ...state.loading, [key]: true },
        error: { ...state.error, [key]: null },
      };
    }
    case FETCH_RECOMMENDATION_SUCCESS: {
      const key = `${payload.pageName}_${payload.strategy}`;
      return {
        ...state,
        loading: { ...state.loading, [key]: false },
        data: { ...state.data, [key]: payload?.products },
      };
    }
    default:
      return state;
  }
}
